import { render, staticRenderFns } from "./OneCategoriesDropdownComponent.vue?vue&type=template&id=e0022866&scoped=true&lang=pug&"
import script from "./OneCategoriesDropdownComponent.vue?vue&type=script&lang=ts&"
export * from "./OneCategoriesDropdownComponent.vue?vue&type=script&lang=ts&"
import style0 from "./OneCategoriesDropdownComponent.vue?vue&type=style&index=0&id=e0022866&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_vd7qwssw5i3h3fjzjs5bz4d2ha/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0022866",
  null
  
)

export default component.exports